import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TranslocoService } from '@jsverse/transloco';
import { Perm, PermissionService } from 'app/core/permissions';
import { catchError, Observable, throwError } from 'rxjs';

/** Resposta 400 das operações do aluguel quando falta a configuração de depósitos. */
export const MENSAGEM_CONFIGURACAO_PENDENTE = 'Configure os depósitos do aluguel.';

export function configuracaoPendente(e: unknown): boolean {
  return e instanceof HttpErrorResponse && e.status === 400 && e.error?.error === MENSAGEM_CONFIGURACAO_PENDENTE;
}

/** Aviso com link para a configuração; um por vez, mesmo com várias chamadas falhando juntas. */
@Injectable({ providedIn: 'root' })
export class AvisoConfiguracaoAluguelService {
  private _confirm = inject(FuseConfirmationService);
  private _transloco = inject(TranslocoService);
  private _router = inject(Router);
  private _permissoes = inject(PermissionService);
  private aberto = false;

  avisar(): void {
    if (this.aberto || this._router.url.startsWith('/aluguel/configuracoes')) {
      return;
    }

    const t = (chave: string) => this._transloco.translate(chave);
    const podeConfigurar = this._permissoes.has(Perm.ALUGUEL_CONFIGURACOES_LIST);

    this.aberto = true;
    this._confirm
      .open({
        title: t('aluguel.configuracao.pendente'),
        message: t(podeConfigurar ? 'aluguel.configuracao.pendenteDica' : 'aluguel.configuracao.pendenteSemPermissao'),
        icon: { show: true, name: 'heroicons_outline:exclamation-triangle', color: 'warning' },
        actions: {
          confirm: { show: podeConfigurar, label: t('aluguel.configuracao.configurar'), color: 'primary' },
          cancel: { label: t('messages.close') },
        },
      })
      .afterClosed()
      .subscribe((r) => {
        this.aberto = false;

        if (r === 'confirmed') {
          this._router.navigate(['/aluguel/configuracoes']);
        }
      });
  }
}

export const configuracaoPendenteInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const aviso = inject(AvisoConfiguracaoAluguelService);

  return next(req).pipe(
    catchError((e) => {
      if (configuracaoPendente(e)) {
        aviso.avisar();
      }

      return throwError(() => e);
    }),
  );
};
